import * as React from 'react'
import { Column } from '../types'
import TextInput from './text_input'
import NumberInput from './number_input'
import DateInput from './date_input'
import SelectInput from './select_input'

interface FieldInputProps {
  column: Column
  value: string | number | string[] | number[] | null
  onChange: (value: string | number | string[] | number[] | null) => void
  fieldId: string
}

export default function FieldInput({
  column,
  value,
  onChange,
  fieldId,
}: FieldInputProps) {
  if (column.type === 'Projects::Columns::Text') {
    return (
      <TextInput
        column={column}
        value={value}
        onChange={onChange}
        fieldId={fieldId}
      />
    )
  }

  if (column.type === 'Projects::Columns::Number') {
    return (
      <NumberInput
        column={column}
        value={value}
        onChange={onChange}
        fieldId={fieldId}
      />
    )
  }

  if (column.type === 'Projects::Columns::Date') {
    return (
      <DateInput
        column={column}
        value={value}
        onChange={onChange}
        fieldId={fieldId}
      />
    )
  }

  if (column.type === 'Projects::Columns::Select') {
    // Select columns use option IDs (numbers), not strings
    const selectValue = value as number | number[] | null
    return (
      <SelectInput
        column={column}
        value={selectValue}
        onChange={onChange}
        fieldId={fieldId}
      />
    )
  }

  // Default fallback to text input
  return (
    <TextInput
      column={column}
      value={value}
      onChange={onChange}
      fieldId={fieldId}
    />
  )
}
